export default "__VITE_ASSET__DoHdhNFC__"